<template>
  <div class="relative p-2 hover:bg-fh-gray-bg border border-fh-gray-bg m-1">
    <div
      @click="goToProductPage"
      class="w-full"
      :class="{ 'cursor-zoom-in': available }"
    >
      <img
        v-if="Array.isArray(images) && images.length > 0"
        class="object-cover aspect-square w-full"
        :src="'/storage/product-images/' + images[0] + '/400.jpg'"
      />
      <!-- <img
        class="object-cover aspect-square w-full"
        src="//dummyimage.com/200/ccc/666?text=%E5%90%83%E8%B2%A8%E5%AE%B6"
      /> -->
    </div>
    <div
      class="mt-2 text-black h-[48px] overflow-hidden text-ellipsis cursor-pointer"
      @click="goToProductPage"
    >
      {{ name }}
    </div>
    <div class="flex items-center justify-between h-[58px] mt-2 cursor-pointer">
      <div @click="goToProductPage">
        <template>
          <!-- v-if="price_tag == 'vertical'" -->
          <div class="flex">
            <div
              :class="{ 'line-through': is_on_sale }"
              class="text-fh-gray mt-1"
            >
              {{
                parseInt(settings.discount.original_price ?? price)
                  | commaFormat
                  | priceFormat
              }}
            </div>
            <div v-if="is_on_sale" class="text-red mt-1 ml-1">
              {{ parseInt(price) | commaFormat | priceFormat }}
            </div>
          </div>
          <div class="flex">
            <div
              :class="{ 'line-through': is_on_sale }"
              class="text-fh-blue text-sm"
            >
              CV
              {{ parseInt(settings.discount.original_cv ?? cv) | commaFormat }}
            </div>
            <div v-if="is_on_sale" class="text-red text-sm ml-1">
              CV {{ parseInt(cv) | commaFormat }}
            </div>
          </div>
          <div
            v-if="is_on_sale && settings.on_sale?.enabled"
            class="text-red text-sm"
          >
            {{ settings.on_sale.name }}
          </div>
        </template>
      </div>
      <div>
        <button
          v-if="!available"
          class="pi pi-times w-10 h-10 rounded-full hover:text-fh-blue hover:bg-fh-pink"
          title="產品已下架或不開放購買"
          style="font-size: 24px"
          @click="
            $toast.add({
              severity: 'info',
              summary: '產品已下架或不開放購買',
              life: 10000,
            })
          "
        />
        <template v-else>
          <button
            v-if="
              settings.time_limit &&
              !this.dayjs().isBetween(
                settings.duration.start,
                settings.duration.end,
                '[)'
              )
            "
            class="pi pi-clock w-10 h-10 rounded-full hover:text-fh-blue hover:bg-fh-pink"
            title="非開放銷售期間"
            style="font-size: 24px"
            @click="
              $toast.add({
                severity: 'info',
                summary: '商品非開放銷售期間',
                detail:
                  '銷售期間為 ' +
                  dayjs(settings.duration.start).format('YYYY年MM月DD日') +
                  ' 至 ' +
                  dayjs(settings.duration.end).format('YYYY年MM月DD日'),
                life: 10000,
              })
            "
          ></button>
          <template v-else>
            <button
              v-if="quantity > 0"
              class="pi pi-shopping-cart w-10 h-10 rounded-full hover:text-fh-blue hover:bg-fh-pink"
              style="font-size: 24px"
              @click="showOverlay($event, showQuantityInput)"
            />
            <button
              v-else
              class="w-10 h-10 rounded-full hover:text-fh-blue hover:bg-fh-pink"
              disabled
            >
              完售
            </button>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    relativePath: {
      type: String,
      default() {
        return null;
      },
    },
    priceTag: {
      type: String,
      default() {
        return "vertical";
      },
    },
    available: {
      type: Number,
      default: 1,
    },
    id: {},
    slug: {},
    type: {},
    name: {},
    images: {
      type: Array,
      default() {
        return [];
      },
    },
    includes: {},
    price: {},
    cv: {},
    quantity: {},
    attributes: {},
    settings: {},
    showQuantityInput: {
      type: Boolean,
      default() {
        return true;
      },
    },
  },
  filters: {
    priceFormat: function (value) {
      return "$" + value;
    },
    commaFormat: function (value) {
      return value
        .toString()
        .replace(
          /^(-?\d+?)((?:\d{3})+)(?=\.\d+$|$)/,
          function (all, pre, groupOf3Digital) {
            return pre + groupOf3Digital.replace(/\d{3}/g, ",$&");
          }
        );
    },
  },
  data() {
    return {
      price_tag: "horizontal",
      desired: 1,
      is_on_sale: this.settings.on_sale ? true : false,
    };
  },
  methods: {
    showOverlay(event, show_quantity) {
      let event_name = "shopping_cart.quick_add.toggle";
      if (this.type == "pack") {
        event_name = "shopping_cart.quick_add_pack.toggle";
      }

      this.$gemit(
        event_name,
        event,
        show_quantity,
        this.name,
        this.type,
        this.id,
        this.includes ?? [],
        this.desired,
        this.quantity,
        this.attributes ?? {},
        this.settings ?? {}
      );
    },
    goToProductPage() {
      if (!this.available) return;
      if (this.relativePath == null) {
        this.$inertia.visit(route("product", this.slug));
      } else {
        this.$inertia.visit(this.relativePath + "/" + this.slug);
      }
    },
  },
  mounted() {
    this.price_tag =
      String(this.priceTag).toLowerCase() === "vertical"
        ? "vertical"
        : "horizontal";
  },
};
</script>

<style lang="postcss">
</style>